module.exports = __webpack_public_path__ + "static/media/VivianLeTran@2x.d6255cc3.png";